import { Pipe, PipeTransform } from '@angular/core';
import { format, Locale } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { fr } from 'date-fns/locale/fr';

@Pipe({
  name: 'timeFormat',
  standalone: true
})

export class TimeFormatPipe implements PipeTransform {

  transform(value: string | number | Date, formatStr: string = 'dd/MM/yyyy', localeCode: string = 'en'): string {
    if (!value) return '';

    const date = new Date(value);

    // mapping simple code -> locale
    const locales: Record<string, Locale> = {
      fr,
      en: enUS
      // tu peux ajouter d'autres locales ici
    };

    const locale = locales[localeCode] || enUS;
    try {
      return format(date, formatStr, { locale });
    } catch (e) {
      console.error(`Invalid date or format (${formatStr}):`, e);
      return '';
    }
  }
}